import React from 'react';
import clsx from 'clsx';

interface GridProps {
  children: ReactChildren;
  className?: string;
  tag?: 'div' | 'ul';
}

const Grid = ({ children, className, tag: Tag = 'div' }: GridProps) => (
  <Tag
    className={clsx(
      'tw-grid tw-gap-4 tw-px-4 chromebook-plus:tw-pr-16 chromebook-plus:tw-pl-0 chromebook-plus:tw-ml-8',
      'tw-grid-cols-1',
      'card-2col:tw-grid-cols-[repeat(2,minmax(0,36rem))]',
      'chromebook-plus:tw-grid-cols-[repeat(3,minmax(20rem,36rem))]',
      Tag === 'ul' && 'tw-list-none tw-my-0',
      className,
    )}
  >
    {children}
  </Tag>
);

export default Grid;
